import React from "react";

export default function PDFIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="48" height="64" viewBox="0 0 48 64">
  <g id="Gruppe_269" data-name="Gruppe 269" transform="translate(-520 -568)">
    <g id="Gruppe_268" data-name="Gruppe 268">
      <path id="Pfad_1265" data-name="Pfad 1265" d="M0,0H32L48,16V64H0Z" transform="translate(520 568)" fill="#ebe9e8"/>
      <path id="Pfad_1264" data-name="Pfad 1264" d="M5116,3565l16,16h-16Z" transform="translate(-4564 -2997)" fill="#b2b0ae"/>
    </g>
    <text id="PDF" transform="translate(531 611)" fill="#383633" font-size="14" font-family="AlbertSans-SemiBold, Albert Sans" font-weight="600"><tspan x="0" y="0">PDF</tspan></text>
  </g>
</svg>;
}